import * as React from "react";
const SvgFiRrBowlSoftServe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bowl-soft-serve_svg__a)">
      <path
        fill="#062147"
        d="M23.982 11.143c-.165-1.651-1.572-2.967-3.275-3.127q.381-.813.275-1.873C20.806 4.38 19.214 3 17.357 3h-1.59c-.621-1.14-1.623-2.36-2.87-2.871a1.71 1.71 0 0 0-1.528.114 1.79 1.79 0 0 0-.862 1.334A5.2 5.2 0 0 1 10.137 3H6.643c-1.856 0-3.45 1.38-3.625 3.143a3.5 3.5 0 0 0 .327 1.869C1.618 8.15.185 9.476.018 11.142a3.51 3.51 0 0 0 .886 2.706 3.5 3.5 0 0 0 1.76 1.05s.81 2.068.839 2.117c1.842 3.073 4.642 3.038 7.486 2.995h.01V22h-3a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2h-3v-1.99h.01c.325.005.76.01 1.077.01 2.48 0 4.775-.28 6.409-3.005.029-.048.838-2.116.838-2.116a3.5 3.5 0 0 0 1.76-1.051 3.51 3.51 0 0 0 .887-2.705zm-5.244 4.913c-1.19 1.932-2.661 2-5.591 1.955-.347-.005-1.946-.005-2.294 0-2.926.045-4.4-.023-5.591-1.955L4.85 15h14.298zm2.875-3.55c-.284.314-.69.494-1.113.494h-17a1.504 1.504 0 0 1-1.492-1.66C2.083 10.59 2.8 10 3.642 10h8.357a1 1 0 0 0 0-2h-5.5a1.504 1.504 0 0 1-1.492-1.66C5.082 5.59 5.8 5 6.64 5h4.104a1 1 0 0 0 .847-.47c.4-.64.71-1.512.854-2.39.655.417 1.355 1.293 1.786 2.265.16.36.519.595.914.595h2.21c.84 0 1.559.589 1.634 1.342.075.75-.12 1.27-1.337 1.72A1 1 0 0 0 17.998 10h2.357c.84 0 1.559.589 1.634 1.342.043.433-.091.846-.38 1.164z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bowl-soft-serve_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBowlSoftServe;
